"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStateData = void 0;
const tslib_1 = require("tslib");
const __elasticsearch_1 = require("../../../__elasticsearch");
const ElasticsearchEnums_1 = require("../../../__types/__enums/ElasticsearchEnums");
const getElasticsearchSortForSortParams_1 = require("../../__common/elasticsearchQuery/getElasticsearchSortForSortParams");
const parseElasticsearchResult_1 = require("../../__common/parseElasticsearchResult");
function getStateData(input, elasticsearchClient = null) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { queryInput, scroll, sortParams } = input;
        const { _source: incomingProjection, body, from = 0, size = 20 } = queryInput;
        let query = {
            index: ElasticsearchEnums_1.ElasticsearchIndicesEnum.STATE,
            type: ElasticsearchEnums_1.ElasticsearchTypesEnum.STATE,
            body
        };
        if (incomingProjection) {
            query.body._source = {
                includes: incomingProjection.includes || incomingProjection.include,
                excludes: incomingProjection.excludes || incomingProjection.include
            };
            if (query.body._source.includes) {
                query.body._source.includes = query.body._source.includes.filter((src) => src !== 'user' && src !== 'content' && src !== 'manager');
                if (query.body._source.includes.length === 0) {
                    delete query.body._source.includes;
                }
            }
        }
        if (scroll) {
            query = Object.assign(Object.assign({}, query), { scroll, size });
        }
        else {
            query = Object.assign(Object.assign({}, query), { from, size });
        }
        if (!elasticsearchClient) {
            elasticsearchClient = yield __elasticsearch_1.getElasticsearchClient(ElasticsearchEnums_1.ElasticsearchIndicesUrlMapping.state);
        }
        if (sortParams) {
            query.body.sort = getElasticsearchSortForSortParams_1.getElasticsearchSortForSortParams(sortParams);
        }
        const result = yield elasticsearchClient.search(query);
        return parseElasticsearchResult_1.parseUserContentMetricsResult(result);
    });
}
exports.getStateData = getStateData;
//# sourceMappingURL=getStateData.js.map